import script from "./AcademicCatalogManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./AcademicCatalogManager.vue?vue&type=script&setup=true&lang=ts"

import "./AcademicCatalogManager.vue?vue&type=style&index=0&id=2b582cc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b582cc6"]])

export default __exports__